import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import UiIcon from "./UiIcon";
import "./ui.css";

// navigator.clipboard needs a secure context (HTTPS or localhost); fall back
// to execCommand so copying still works on plain-HTTP environments.
const fallbackCopy = (text) => {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try {
    return document.execCommand("copy");
  } catch (e) {
    return false;
  } finally {
    document.body.removeChild(ta);
  }
};

const copyText = (text) =>
  navigator.clipboard && window.isSecureContext
    ? navigator.clipboard.writeText(text).then(
        () => true,
        () => fallbackCopy(text)
      )
    : Promise.resolve(fallbackCopy(text));

export default function CopyableValue({ value, mono }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef();
  useEffect(() => () => clearTimeout(timer.current), []);

  if (value === null || value === undefined || value === "" || value === "-") return value ?? null;
  const text = String(value);

  const onCopy = (e) => {
    e.stopPropagation(); // never toggles row selection
    copyText(text).then((ok) => {
      if (!ok) return;
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 1100);
    });
  };

  return (
    <button
      type="button"
      className={`simcc-copy${mono ? " simcc-copy--mono" : ""}${copied ? " simcc-copy--done" : ""}`}
      title={`Copy ${text}`}
      onClick={onCopy}
    >
      <span className="simcc-copy__value">{copied ? "Copied" : text}</span>
      <UiIcon name={copied ? "check" : "copy"} size={12} strokeWidth={copied ? 3 : 2} className="simcc-copy__icon" />
    </button>
  );
}

CopyableValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mono: PropTypes.bool,
};

CopyableValue.defaultProps = {
  value: undefined,
  mono: false,
};
